<div class="dialog-container">
	<h2 mat-dialog-title>{{ data.title }}</h2>
	<mat-dialog-content>
		<mat-form-field appearance="outline" style="width: 100%;">
			<mat-label>Select Department</mat-label>
			<mat-select [(ngModel)]="selectedDepartmentId">
				<mat-option *ngFor="let dept of departments" [value]="dept.code" [disabled]="currentDeptId && dept.code === currentDeptId">
					{{ dept.value }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button mat-stroked-button (click)="onCancel()">Cancel</button>
		<button mat-flat-button color="primary" [disabled]="!selectedDepartmentId" (click)="onTransfer()">Transfer</button>
	</mat-dialog-actions>
</div>
